import { OperationsManagementSummaryTableV3 } from "features/operationsManagement/OperationsManagementSummaryTableV3";
import "style/discoverPage.css";

/**
 * Operations Management Summary Page
 *
 * This page displays the summary table for operations management.
 * Uses the OperationsManagementSummaryTableV3 component with column visibility,
 * filters, and custom views.
 */
export function OperationsManagementSummaryPage() {
	return (
		<div className="discover-container discover-container--full-width">
			<OperationsManagementSummaryTableV3 />
		</div>
	);
}

export default OperationsManagementSummaryPage;
